<template>
  <div  class="grid-side-space">
    <div class="episData">
      <div>
        <h4>{{ $t("faq.main_text1") }}</h4>
          <p>{{ $t("faq.main_text2") }}</p>
      </div>
      <div>
        <h4>{{ $t("default.company") }}</h4>
        <span>{{ $t("default.company_address") }}</span>
        <span>{{ $t("default.company_city") }}</span>
        <span>{{ $t("default.company_country") }}</span>
        <span>E: <a href="mailto:info@episcenterklub.si" target="_blank">info@episcenterklub.si</a></span>
        <span>T: <a href="tel:+38614702600">+386 1 470 26 00</a> </span>

      </div>
    </div>
    <strong>{{ $t("faq.main_title1") }}</strong>
    <h3 class="AccMidTitle">{{ $t("faq.main_title2") }}</h3>
    <Accordion>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text5") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text6") }}</div>
        </template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text7") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text8") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text9") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text10") }}</div></template>
      </AccordionItem>
    </Accordion>

    <h3 class="AccMidTitle none">{{ $t("faq.main_title3") }}</h3>
    <Accordion>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text11") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text12") }}</div>
        </template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text13") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text14')"></span></div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text15") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text16") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text17") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text18')"></span></div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text19") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text20") }}</div></template>
      </AccordionItem>
    </Accordion>

    <h3 class="AccMidTitle none">{{ $t("faq.main_title4") }}</h3>
    <Accordion>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text21") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text22") }}</div>
        </template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text23") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text24") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text25") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text26") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text27") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text28')"></span></div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text29") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text30')"></span></div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text31") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text32") }}</div>
        </template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text33") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text34") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text35") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text36") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text37") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text38") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text39") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text40") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text41") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text42')"></span></div></template>
      </AccordionItem>
    </Accordion>

    <h3 class="AccMidTitle none">{{ $t("faq.main_title5") }}</h3>
    <Accordion>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text43") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text44')"></span></div>
        </template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text45") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text46") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text47") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text48')"></span></div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text49") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text50')"></span></div></template>
      </AccordionItem>

    </Accordion>

    <h3 class="AccMidTitle none">{{ $t("faq.main_title6") }}</h3>
    <Accordion>

      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text53") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content">{{ $t("faq.main_text54") }}</div></template>
      </AccordionItem>
      <AccordionItem>
        <template slot="accordion-trigger">
          <h4>{{ $t("faq.main_text55") }} <span class="openCloseIcon"></span></h4>
        </template>

        <template slot="accordion-content">
          <div class="content"><span v-html="$t('faq.main_text56')"></span></div></template>
      </AccordionItem>


    </Accordion>

  </div>
</template>
<script>
import Accordion from "@/components/Accordion/Accordion";
import AccordionItem from "@/components/Accordion/Accordion-item";
export default {
  data() {
    return {

    };
  },
  computed: {},
  components: {AccordionItem, Accordion},


};
</script>
<style scoped src="@/assets/css/bootstrap.css"></style>
<style>
</style>